<section class="main-search container">
  <div class="main-search__item main-search--padding">
    <label class="form-control form-control--alt form-control--lg">
      <div class="position-relative">
        <input
          type="search"
          name="main_pages_search"
          [(ngModel)]="input"
          debounce
          (debounce)="change(2)"
          class="pr-5"
          [placeholder]="'MAIN_SEARCH_PLACEHOLDER' | translate"
          appAutofocus
          spellcheck="false"
        />

        <button
          type="button"
          (click)="change(1)"
          class="postfix icon-button"
          attr.aria-label="{{ 'SEARCH' | translate }}"
        >
          <div [inlineSVG]="'../assets/img/icons/search-icon-3.svg'"></div>
        </button>
      </div>
    </label>
  </div>
  @if (results) {
    <ng-scrollbar #ps track="all" appearance="compact">
      <div class="main-search__item">
        <app-search-items [data]="results" [ps]="ps"></app-search-items>
      </div>
    </ng-scrollbar>
  }

  @if (isLoading) {
    <div class="spinner spinner--alt text-center text-secondary mb-5">
      <div class="spinner-grow" role="status">
        <span class="sr-only">{{ 'LOADING' | translate }}</span>
      </div>
    </div>
  }
</section>
